import { render, staticRenderFns } from "./QuotationApproveMes.vue?vue&type=template&id=1fbf853a&"
import script from "./QuotationApproveMes.vue?vue&type=script&lang=js&"
export * from "./QuotationApproveMes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports